import common from '../base/common';

class Header{

    constructor(){

        this.checkPosition = this.checkPosition.bind(this);
        this.bindEvents();

    }

    bindEvents(){

        this.checkPosition();
        common.$window.on('scroll', this.checkPosition);

    }

    unBindEvents(){

        common.$window.off('scroll', this.checkPosition);

    }

    checkPosition(){

        if(common.$window.scrollTop() >= common.screen.height * 0.8 && !common.$body.hasClass('scrolled'))
            common.$body.addClass('scrolled')
        else if(common.$window.scrollTop() < common.screen.height * 0.8 && common.$body.hasClass('scrolled'))
            common.$body.removeClass('scrolled')

    }

}

export default new Header();



// WEBPACK FOOTER //
// ./js/layouts/header.js